function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

import React, { useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Icon } from '../Icon';
import { Truncate } from '../Truncate';

var Toast = function Toast(_ref) {
  var className = _ref.className,
      ctaText = _ref.ctaText,
      message = _ref.message,
      error = _ref.error,
      onCtaClick = _ref.onCtaClick,
      closeBtn = _ref.closeBtn,
      onClose = _ref.onClose;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      close = _useState2[0],
      setClose = _useState2[1];

  var toastClassName = classNames('w-100p p-4 br-4 flex flex-middle flex-between elevation-3', {
    'bg-error-600': error === true,
    'bg-neutral-700': !error
  }, className);
  var ctaClassName = classNames('fs-3 c-pointer hover:td-underline fw-500 ml-2 mx-6', {
    'c-white': error === true,
    'c-secondary-300': !error
  });

  var onCloseClick = function onCloseClick(event) {
    setClose(!close);
    onClose(event);
  };

  return React.createElement(React.Fragment, null, !close && React.createElement("div", {
    className: toastClassName
  }, React.createElement(Truncate, {
    as: "span",
    width: ctaText && closeBtn ? 850 : null,
    className: "fs-3 c-white"
  }, message), React.createElement("div", {
    className: "flex flex-middle"
  }, ctaText && React.createElement("span", {
    className: ctaClassName,
    onClick: onCtaClick
  }, ctaText), closeBtn && React.createElement("div", {
    className: "br-100 flex flex-center flex-middle c-pointer",
    onClick: onCloseClick,
    style: {
      height: '20px',
      width: '20px',
      backgroundColor: 'rgba(0,0,0,0.1)'
    }
  }, React.createElement(Icon, {
    icon: "cross",
    stroke: "#fff",
    height: '12',
    width: '12'
  })))));
};

Toast.defaultProps = {
  className: '',
  error: false,
  ctaText: '',
  message: '',
  closeBtn: true,
  onClose: function onClose() {}
};
Toast.propTypes = {
  className: PropTypes.string,
  error: PropTypes.bool,
  ctaText: PropTypes.string,
  message: PropTypes.string,
  closeBtn: PropTypes.bool,
  onClose: PropTypes.func
};
Toast.displayName = 'Toast';
export { Toast };